import AuditTrail from './AuditTrail';

export default AuditTrail;
